import React, { useState, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import CartItemsPopup from 'arts/components/cart_items_popup';
import Share from 'arts/components/ArtistWorks/share';
import {
  Sidebar, Modal, Input
} from 'semantic-ui-react';
import { trackEvent } from 'arts/config/analytics';
import * as classes from './classes.module.scss';
import CommandBar from '../command_bar';
import Panel from '../panel';
import Canvas from '../canvas';
import LocaleSelection from '../../../shared/locale_selection';
import CookiesConsent from '../../../shared/cookies_consent';

const Application = ({
  sharingUrl, previewSrc, name
}) => {
  const [showSharing, setShowSharing] = useState(false);

  useEffect(() => {
    const { wallId, currency } = window.wall;
    trackEvent('wall builder', { wallId, currency });
  }, []);

  useEffect(() => {
    if (sharingUrl) { setShowSharing(true); }
  }, [sharingUrl]);

  const closeSharing = () => { setShowSharing(false); };

  const description = useMemo(() => `${ name } on Artfully Walls`, [name]);

  return (
    <div className={ classes.builder }>
      <LocaleSelection />
      <CookiesConsent />
      <Modal
        open={ showSharing }
        closeOnDimmerClick
        className={ classes.modal }
        onClose={ closeSharing }
      >
        <Modal.Header>Share This Wall</Modal.Header>
        <Modal.Content image>
          <Modal.Description>
            <Input type="text" value={ sharingUrl } readOnly className={ classes.input } />
            <Share imageUrl={ previewSrc } href={ sharingUrl } description={ description } />
          </Modal.Description>
        </Modal.Content>
      </Modal>
      <CartItemsPopup />
      <CommandBar />
      <div className={ classes.content }>
        <Sidebar.Pushable>
          <Panel />
          <Sidebar.Pusher>
            <Canvas />
          </Sidebar.Pusher>
        </Sidebar.Pushable>
      </div>
    </div>
  );
};

Application.propTypes = {
  sharingUrl: PropTypes.string,
  previewSrc: PropTypes.string,
  name: PropTypes.string
};

export default Application;
